import { PageContainer } from "../../../components/pageContainer/PageContainer";
import { ReactElement } from "react";
import { useNavigate } from "react-router";
import { useDashboardContext } from "../../../components/dashboard/Dashboard.shared";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { BuyerPaymentPreferencePaymentMethods } from "./BuyerPaymentPreferencePaymentMethods";
import { BUSINESS } from "../../../constants/routes";

export function PaymentMethodSettings(): ReactElement {
  const navigate = useNavigate();
  const { isTwoPanel } = useDashboardContext();

  return (
    <>
      <NavigationBar
        title={"Payment Methods"}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={isTwoPanel ? undefined : () => navigate(BUSINESS)}
      />
      <PageContainer>
        <div className="flex flex-col gap-4">
          <BuyerPaymentPreferencePaymentMethods />
        </div>
      </PageContainer>
    </>
  );
}
